import {useIntl} from 'react-intl'

export default function MarketPlace({
  values,
}: {
  values: {
    firstName: string
    lastName: string
    addressLine: string
    city: string
    state: string
    zipCode: string
    country: string
    orderNo: string
    orderDate: string
    paymentType: string
    paymentStatus: string
    paymentDate: string
    totalPaid: string
    items: any[]
  }
}) {
  const intl = useIntl()

  const discount = 0

  const companyAddress = 'Esentepe, Büyükdere Cd. No:102, 34394'
  const companyAddressLine2 = 'Şişli/İstanbul - Turkey'

  return (
    <div className='card card-custom gutter-b'>
      <div className='card-body'>
        <div className='row justify-content-center py-8 px-8 py-md-27 px-md-0'>
          <div className='col-md-10'>
            <div className='d-flex justify-content-between pb-10 pb-md-20 flex-column flex-md-row'>
              <h1 className='display-4 font-weight-boldest mb-10'>
                {intl.formatMessage({id: 'CHECKOUT.PURCHASE.ORDER_DETAIL'})}
              </h1>
              {/* <div className="d-flex flex-column align-items-md-end px-0">
                <div className="mb-5">
                  <img src="http://localhost:3011/static/media/logo.00f8cbfb964d45be2e8306b5010bf77b.svg" alt="" />
                </div>
                <span className=" d-flex flex-column align-items-md-end opacity-70">
                  <div>{companyAddress}</div>
                  <div>{companyAddressLine2}</div>
                </span>
              </div> */}
            </div>
            <div className='border-bottom w-100'></div>
            <div className='d-flex justify-content-between pt-6'>
              <div className='d-flex flex-column flex-root'>
                <span className='font-weight-bolder mb-2'>
                  {intl.formatMessage({id: 'CHECKOUT.SUCCESS.ORDER_DATE'})}
                </span>
                <span className='opacity-70'>{new Date().toLocaleDateString()}</span>
              </div>
              <div className='d-flex flex-column flex-root'>
                <span className='font-weight-bolder mb-2'>
                  {intl.formatMessage({id: 'CHECKOUT.SUCCESS.ORDER_ID'})}
                </span>
                <span className='opacity-70'>{values?.orderNo}</span>
              </div>
              <div className='d-flex flex-column flex-root'>
                <span className='font-weight-bolder mb-2'>
                  {intl.formatMessage({id: 'CHECKOUT.SUCCESS.DELIVERED_TO'})}
                </span>
                <span className='opacity-70'>
                  {values?.addressLine}
                  <br />
                  {values.zipCode}, {values.state}, {values.country}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className='row justify-content-center py-8 px-8 py-md-10 px-md-0'>
          <div className='col-md-10'>
            <div className='table-responsive'>
              <table className='table'>
                <thead>
                  <tr>
                    <th className='pl-0 font-weight-bold   text-uppercase'>
                      {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.ORDERED'})}
                    </th>
                    <th className='text-right font-weight-bold  text-uppercase'>
                      {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.QUANTITY'})}
                    </th>
                    <th colSpan={2} className='text-right font-weight-bold  text-uppercase'>
                      {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.PRICE'})}
                    </th>
                    {/* <th className="text-right pr-0 font-weight-bold  text-uppercase">{intl.formatMessage({ id: 'CHECKOUT.PURCHASE.TABLE.AMOUNT' })}</th> */}
                  </tr>
                </thead>
                <tbody>
                  {values &&
                    values.items &&
                    values.items.map((item, index) => (
                      <tr className='font-weight-boldest'>
                        <td className='border-0 pl-0 pt-7 d-flex align-items-center'>
                          <div className='symbol symbol-40 flex-shrink-0 mr-4 bg-light'>
                            {/* <div className="symbol-label" style={{ backgroundImage: `url(${item.product.image})` }}></div> */}
                            <img src={item.product.image} alt='' style={{maxHeight: 100}} />
                          </div>
                          <span className='ml-2'>{item.product.name}</span>
                        </td>
                        <td className='text-right pt-7 align-middle'>1</td>
                        <td colSpan={2} className='text-right pt-7 align-middle'>
                          ${item.product.price}
                        </td>
                        {/* <td className="text-primary pr-0 pt-7 text-right align-middle">${item.price * (item?.quantity || 1)}</td> */}
                      </tr>
                    ))}
                  <tr>
                    <td colSpan={2}></td>
                    <td className='font-weight-bolder text-right'>
                      {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.SUBTOTAL'})}
                    </td>
                    {/* <td className="font-weight-bolder text-right pr-0">${values.items.reduce((acc, item) => acc + (item.price * (item?.quantity || 1)), 0)}</td> */}
                    <td className='font-weight-bolder text-right pr-0'>
                      $
                      {values?.items &&
                        values.items.reduce((acc, item) => acc + item.product.price, 0)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className='border-0 pt-0'></td>
                    <td className='border-0 pt-0 font-weight-bolder text-right'>
                      {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.DISCOUNT'})}
                    </td>
                    <td className='border-0 pt-0 font-weight-bolder text-right pr-0'>
                      ${discount}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className='border-0 pt-0'></td>
                    <td className='border-0 pt-0 font-weight-bolder font-size-h5 text-right'>
                      {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.TOTAL'})}
                    </td>
                    <td className='border-0 pt-0 font-weight-bolder font-size-h5 text-success text-right pr-0'>
                      {/* {/* ${values.items.reduce((acc, item) => acc + (item.price * (item?.quantity || 1)), 0) + discount} 0} */}
                      $
                      {values?.items &&
                        values.items.reduce((acc, item) => acc + item.product.price, 0) + 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className='row justify-content-center bg-gray-100 py-8 px-8 py-md-10 px-md-0 mx-0'>
          <div className='col-md-10'>
            <div className='table-responsive'>
              <table className='table'>
                <thead>
                  <tr>
                    <th className='font-weight-bold   text-uppercase'>
                      {intl.formatMessage({id: 'CHECKOUT.SUCCESS.PAYMENT.TYPE'})}
                    </th>
                    <th className='font-weight-bold   text-uppercase'>
                      {intl.formatMessage({id: 'CHECKOUT.SUCCESS.PAYMENT.STATUS'})}
                    </th>
                    <th className='font-weight-bold   text-uppercase'>
                      {intl.formatMessage({id: 'CHECKOUT.SUCCESS.PAYMENT.DATE'})}
                    </th>
                    <th className='font-weight-bold   text-uppercase text-right'>
                      {intl.formatMessage({id: 'CHECKOUT.SUCCESS.PAYMENT.TOTAL_PAID'})}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='font-weight-bolder'>
                    <td>{values.paymentType}</td>
                    <td>{values.paymentStatus}</td>
                    <td>{new Date().toLocaleDateString()}</td>
                    <td className='text-primary font-size-h3 font-weight-boldest text-right'>
                      {/* ${values.totalPaid} */}$
                      {values?.items &&
                        values.items.reduce((acc, item) => acc + item.product.price, 0) + 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
